const PaymentProtection = ({
  color = "currentColor",
  width = 24,
  height = 24,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width={width}
    height={height}
    fill={color}
    aria-hidden="true"
    {...props}
  >
    <path d="M33.819 44.817H8.999a3.003 3.003 0 0 1-3-3V22.495h46.138v4.483a1 1 0 0 0 2 0v-11.54a5.006 5.006 0 0 0-5-4.999H9a5.006 5.006 0 0 0-5 5v26.378a5.006 5.006 0 0 0 5 5h24.819a1 1 0 0 0 0-2zM5.999 15.44a3.003 3.003 0 0 1 3-3h40.138a3.003 3.003 0 0 1 3 3v1.49H6zm0 3.49h46.138v1.566H6z" />
    <path d="M11.24 38.321a1 1 0 0 0 0 2h7.13a1 1 0 0 0 0-2zM59.586 33.446c-.12-.572-.18-1.32-.843-1.511l-10.88-3.501a1.011 1.011 0 0 0-.613 0l-10.878 3.501c-.66.194-.72.936-.844 1.51-1.601 8.007 1.522 15.178 7.955 18.268l3.641 1.75a.998.998 0 0 0 .866 0l3.642-1.75c6.433-3.09 9.555-10.26 7.954-18.267zm-8.82 16.465-3.209 1.54-3.209-1.54c-5.634-2.69-8.323-9.154-6.823-16.246l10.032-3.229 10.033 3.229c1.497 7.094-1.19 13.557-6.823 16.246z" />
    <path d="m52.395 37.553-5.298 4.72-2.335-2.334a1 1 0 0 0-1.414 1.414l3.002 3.002a1 1 0 0 0 1.372.04l6.003-5.349a1 1 0 0 0-1.33-1.493z" />
  </svg>
);

export default PaymentProtection;
